import { post } from '@/utils/examMan/request'
import request from '@/utils/request'

export function save(data) {
  return post('/api/learn/api/sys/group/save', data)
}

export function fetchPaging(data) {
  return post('/api/learn/api/sys/group/paging', data)
}

// 复制群组（GET）
export function copyGroup(id) {
  return request({
    url: '/learn/api/sys/group/copy',
    method: 'get',
    params: { id }
  })
}
